import { API } from "apis";
import Image from "components/common/images/Image";
import ContactDialog from "components/dialog/ContactDialog";
import { ContextModel, CorpDetailModel } from "models";
import React from "react";
import { Utils } from "utils";
import { FaRegHeart } from "react-icons/fa";
import Chip from "components/common/Chip";

type PROPS = {
  showButtons: boolean;
  ctx: ContextModel;
  corp: CorpDetailModel & {
    favorite_corp_id?: string;
    candidate_corp_id?: string;
  };
};

const CorpDetailSideMenu: React.FC<PROPS> = (props) => {
  const ctx = props.ctx;

  const [modalIsOpen, setIsOpen] = React.useState(false);

  // check is favorite or candidate
  const [checkFavCandi, setcheckFavCandi] = React.useState({
    favorite_corp_id: props.corp.favorite_corp_id ?? '',
    candidate_corp_id: props.corp.candidate_corp_id ?? ''
  });

  const onFavorite = async () => {
    ctx.loading.setState(true);
    try {
      // check item has favorite
      if (checkFavCandi.favorite_corp_id) {
        await API.FavoriteCorp.del(checkFavCandi.favorite_corp_id);
      } else {
        await API.FavoriteCorp.add({favorite_corp_id: props.corp.corp_id});
      }

      setcheckFavCandi(prevState => ({
        ...prevState,
        favorite_corp_id: checkFavCandi.favorite_corp_id ? '' : props.corp.corp_id
      }));
    } catch (err) {
      Utils.errorAction(ctx, err);
    }
    ctx.loading.setState(false);
  };

  const onAddCandidate = async () => {
    ctx.loading.setState(true);
    try {
      // check item has candidate
      if (checkFavCandi.candidate_corp_id) {
        await API.CandidateCorp.del(checkFavCandi.candidate_corp_id);
      } else {
        await API.CandidateCorp.add(props.corp.corp_id);
      }

      setcheckFavCandi(prevState => ({
        ...prevState,
        candidate_corp_id: checkFavCandi.candidate_corp_id ? '' : props.corp.corp_id
      }));
    } catch (err) {
      Utils.errorAction(ctx, err);
    }
    ctx.loading.setState(false);
  };

  return (
    <div className="jhk-sidemenu flex flex-col items-center py-8 w-80 item-hover">
      <div className="w-1/2">
        <a href={props.corp.corp_url} target="_blank" rel="noreferrer" className="relative">
          {props.corp?.logo_image && props.corp?.logo_image?.image_url && <Image data={props.corp.logo_image} />}
          <div className="absolute right-0 bottom-0 p-2">{props.corp?.is_hide && <Chip text="非公開" />}</div>
        </a>
      </div>
      <a href={props.corp.corp_url} target="_blank" rel="noreferrer">
        <div className="my-2 px-3 truncate hover:underline" title={props.corp.corp_name}>
          {props.corp.corp_name}
        </div>
      </a>

      <div className="px-8 whitespace-pre-line break-all">{props.corp.catch_phrase}</div>
      {props.showButtons && (
        <>
          <div className="my-4 flex gap-4">
            <button className={`secondary flex items-center gap-1 px-2 py-2 item-favorite ${checkFavCandi.favorite_corp_id ? 'is-favorite' : ''}`} onClick={onFavorite}>
              <FaRegHeart />
              {checkFavCandi.favorite_corp_id ? 'お気に入り済' : 'お気に入り'}
            </button>
            <button className="secondary px-4 py-2" onClick={() => setIsOpen(true)}>
              お問い合わせ
            </button>
          </div>
          <div className="px-8 w-full">
            <button className={`primary w-full py-2 item-candidate ${checkFavCandi.candidate_corp_id ? 'is-favorite' : ''}`} onClick={onAddCandidate}>
              {checkFavCandi.candidate_corp_id ? '商談候補会社に追加済' : '商談候補会社に追加'}
            </button>
          </div>
          <ContactDialog
            ctx={ctx}
            modalIsOpen={modalIsOpen}
            targets={[
              {
                corp_id: props.corp.corp_id,
                corp_name: props.corp.corp_name,
              },
            ]}
            close={() => setIsOpen(false)}
          />
        </>
      )}
    </div>
  );
};

export default CorpDetailSideMenu;
